import { FormField, FormFields, Required, Size } from "../index";
import { Field, FieldProps, FieldRenderProps } from "react-final-form";
import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Theme, WithStyles } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme: Theme) =>
  createStyles({
    card: {
      display: "grid",
      gridTemplateColumns: "100%"
    },
    cardContent: {
      display: "grid",
      gridTemplateColumns: "100%"
    },
    gridFieldWrapper: {
      display: "grid",
      gridTemplateColumns: "40% 55%"
    },
    fieldWrapper: {
      display: "grid",
      gridTemplateColumns: "100%"
    },
    gridlLabel: {
      display: "inline-block",
      padding: theme.spacing(1) * 3,
      textAlign: "right"
    },
    label: {
      display: "inline-block",
      marginLeft: theme.spacing(1) * 5,
      textAlign: "left"
    },
    field: {
      display: "inline-block",
      paddingLeft: theme.spacing(1) * 5,
      paddingRight: theme.spacing(1) * 5,
      paddingTop: theme.spacing(1) * 2,
      paddingBottom: theme.spacing(1) * 2,
      float: "left",
      width: "100%"
    }
  });

export interface ObjFieldProps
  extends FieldRenderProps<any>,
    WithStyles<typeof styles> {
  schema: FormFields;
  values: any;
  noWrap?: boolean;
  readOnly?: boolean;
}

class ObjectFieldComponent extends React.Component<ObjFieldProps> {
  public constructor(props: ObjFieldProps) {
    super(props);
  }

  private prepareComponentProps = (field: FormField) => {
    return {
      values: this.props.values,
      key: field.name,
      name: field.name,
      component: field.type.Component,
      validate: field.type.valid,
      disabled: this.props.readOnly || field.readonly,
      readOnly: this.props.readOnly || field.readonly,
      ...field.type.props
    } as FieldProps<any, any>;
  };

  public render() {
    const { classes, noWrap } = this.props;

    return (
      <>
        {noWrap ? (
          <>
            {this.props.schema.mapFields((field, idx) => {
              const fieldProps = this.prepareComponentProps(field);
              return (
                <div key={field.name + idx}>
                  <Field {...fieldProps} />
                </div>
              );
            }, this.props.values)}
          </>
        ) : (
          <Card variant="outlined" className={classes.card}>
            <CardContent className={classes.cardContent}>
              {this.props.schema.mapFields((field, idx) => {
                const fieldProps = this.prepareComponentProps(field);

                const requiredSuffix =
                  field.type.validators.indexOf(Required) > -1 ? " *" : "";
                const label = (field.title || field.name) + requiredSuffix;

                return (
                  <div
                    className={
                      field.renderSize === Size.BIG
                        ? classes.fieldWrapper
                        : classes.gridFieldWrapper
                    }
                    key={field.name + idx}
                  >
                    <label
                      className={
                        field.renderSize === Size.BIG
                          ? classes.label
                          : classes.gridlLabel
                      }
                    >
                      {label}
                    </label>
                    <div
                      className={
                        field.renderSize === Size.BIG
                          ? classes.field
                          : undefined
                      }
                    >
                      <Field {...fieldProps} />
                    </div>
                  </div>
                );
              }, this.props.values)}
            </CardContent>
          </Card>
        )}
      </>
    );
  }
}

export const ObjField = withStyles(styles, { withTheme: true })(
  ObjectFieldComponent
);
